import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    static values = {
        addLabel: { type: String, default: 'Ajouter une ligne' },
        removeLabel: { type: String, default: 'Retirer' },
    };

    connect() {
        this.prototypeHtml = this.element.getAttribute('data-prototype');
        if (!this.prototypeHtml) {
            return;
        }

        // Toujours croissant : ne jamais réutiliser un index déjà attribué,
        // sinon un ajout après suppression d'une entrée du milieu produit un
        // name[] identique à une entrée existante et écrase ses données à la soumission.
        this.nextIndex = this.entryElements().length;

        this.decorateExistingEntries();
        this.ensureAddButton();
        this.element.addEventListener('click', (event) => this.handleClick(event));
    }

    decorateExistingEntries() {
        this.entryElements().forEach((entry) => this.decorateEntry(entry));
    }

    entryElements() {
        return Array.from(this.element.children).filter(
            (child) => !child.hasAttribute('data-collection-add'),
        );
    }

    decorateEntry(entry) {
        if (entry.dataset.collectionEntry === 'true') {
            return;
        }

        entry.dataset.collectionEntry = 'true';
        entry.classList.add('client-form__collection-entry');

        if (entry.querySelector('[data-collection-remove]')) {
            return;
        }

        const removeButton = document.createElement('button');
        removeButton.type = 'button';
        removeButton.className = 'button button--muted button--small client-form__collection-remove';
        removeButton.textContent = this.removeLabelValue;
        removeButton.dataset.collectionRemove = 'true';
        entry.appendChild(removeButton);
    }

    ensureAddButton() {
        if (this.element.querySelector('[data-collection-add]')) {
            return;
        }

        const addButton = document.createElement('button');
        addButton.type = 'button';
        addButton.className = 'button button--muted button--small client-form__collection-add';
        addButton.textContent = this.addLabelValue;
        addButton.dataset.collectionAdd = 'true';
        this.element.appendChild(addButton);
    }

    handleClick(event) {
        if (event.target.closest('[data-collection-add]')) {
            event.preventDefault();
            this.addEntry();

            return;
        }

        const removeButton = event.target.closest('[data-collection-remove]');
        if (!removeButton) {
            return;
        }

        event.preventDefault();
        this.removeEntry(removeButton.closest('[data-collection-entry="true"]'));
    }

    addEntry() {
        const index = this.nextIndex++;
        const html = this.prototypeHtml.replace(/__name__/g, String(index));
        const template = document.createElement('template');
        template.innerHTML = html.trim();
        const entry = template.content.firstElementChild;

        if (!entry) {
            return;
        }

        this.decorateEntry(entry);

        const addButton = this.element.querySelector('[data-collection-add]');
        this.element.insertBefore(entry, addButton);
    }

    removeEntry(entry) {
        if (!entry) {
            return;
        }

        const deleteInput = entry.querySelector('input[type="checkbox"][name$="[_delete]"]');
        if (deleteInput) {
            deleteInput.checked = true;
            entry.hidden = true;

            return;
        }

        entry.remove();
    }
}
